import { render, staticRenderFns } from "./pesquisar-servicos.vue?vue&type=template&id=d24154f0&scoped=true&"
import script from "./pesquisar-servicos.vue?vue&type=script&lang=js&"
export * from "./pesquisar-servicos.vue?vue&type=script&lang=js&"
import style0 from "./pesquisar-servicos.vue?vue&type=style&index=0&id=d24154f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d24154f0",
  null
  
)

export default component.exports